import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AdditionalContext = Record<string, any>

export const saveVehicleEvent = (context?: AdditionalContext) => ({
  event: {
    name: 'logged-in-favourite',
    category: 'button',
    action: 'favourite',
    label: 'logged in',
  },
  product: [
    {
      vehicle: { ...context?.vehicle },
    },
  ],
})

export const unSaveVehicleEvent = (context?: AdditionalContext) => ({
  event: {
    name: 'logged-in-unfavourite',
    category: 'button',
    action: 'unfavourite',
    label: 'logged in',
  },
  product: [
    {
      vehicle: { ...context?.vehicle },
    },
  ],
})

export const unAuthSaveVehicleEvent = (context?: AdditionalContext) => ({
  event: {
    name: 'logged-out-favourite',
    category: 'button',
    action: 'favourite',
    label: 'logged out',
  },
  product: [
    {
      vehicle: { ...context?.vehicle },
    },
  ],
})

export const sendSaveVehicleEvent = (context?: AdditionalContext) =>
  sendDigitalDataEvent(saveVehicleEvent(context))
export const sendUnSaveVehicleEvent = (context?: AdditionalContext) =>
  sendDigitalDataEvent(unSaveVehicleEvent(context))
export const sendUnAuthSaveVehicleEvent = (context?: AdditionalContext) =>
  sendDigitalDataEvent(unAuthSaveVehicleEvent(context))

export const sendFavouritesAnalyticEvent = (
  isSignedIn: boolean,
  isSaved: boolean,
  context?: AdditionalContext,
) => {
  const signedInUnSavingVehicle = isSaved && isSignedIn
  const signedInSavingVehicle = !isSaved && isSignedIn
  const unAuthSavingVehicle = !isSaved && !isSignedIn

  if (signedInSavingVehicle) sendSaveVehicleEvent(context)
  if (signedInUnSavingVehicle) sendUnSaveVehicleEvent(context)
  if (unAuthSavingVehicle) sendUnAuthSaveVehicleEvent(context)
}
